module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.reportStatus === 'absent') ? _c('div', [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.generateReport
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('campaigns.reportTexts.createReport')))])])]) : (_vm.reportStatus === 'generating') ? _c('div', {
    staticClass: "waiting button is-primary"
  }, [_c('Loader', {
    attrs: {
      "color": "white"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.reportTexts.reportIsBeingGeneratedNow')))])], 1) : (_vm.reportStatus === 'exist' && _vm.reportLink) ? _c('div', [_c('a', {
    staticClass: "button is-success",
    attrs: {
      "href": _vm.reportLink
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.load')))])]), _vm._v(" "), _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.generateReport
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.actions.reCreate')))])])]) : (_vm.reportStatus === 'fail') ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('campaigns.reportTexts.createReportError')))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9881e96"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/campaigns/ReportGenerator.vue
// module id = 453
// module chunks = 42